import { useEffect, useState } from "react";

/**
 * Sant på pekskärm (mobil, platta, appen). Används för att byta ut
 * hover-bubblor mot paneler som går att trycka fram.
 */
export function useIsTouch(): boolean {
  const [touch, setTouch] = useState(false);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia("(pointer: coarse)");
    const update = () => setTouch(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);
  return touch;
}
